import { Link } from 'react-router-dom';
import { formatDateLabel } from '../daily';

interface Props {
  title?: string;
  subtitle?: string;
  dateKey: string;
  isToday: boolean;
  emoji?: string;
}

export default function DailyDoneOverlay({
  title = 'Solved!',
  subtitle,
  dateKey,
  isToday,
  emoji = '🎉',
}: Props) {
  return (
    <div className="daily-overlay">
      <div className="daily-overlay-card">
        <div className="daily-overlay-emoji">{emoji}</div>
        <div className="daily-overlay-title">{title}</div>
        {subtitle && <div className="daily-overlay-sub">{subtitle}</div>}
        <div className="daily-overlay-date">{formatDateLabel(dateKey, isToday)}</div>
        <div className="daily-overlay-note">
          {isToday
            ? 'Come back tomorrow for a fresh puzzle.'
            : 'Today\'s puzzle hasn\'t been published yet — this was the latest.'}
        </div>
        <Link to="/" className="btn btn-primary">
          Back to games
        </Link>
      </div>
    </div>
  );
}
